<template>
  <base-widget
    ref="widget"
    expanded
    :initial-tab="defaultInitialTab"
    :items="tabs"
    :style="minHeight"
    @tabChanged="$emit('tabChanged', $event)"
  >
    <div class="d-flex align-items-center mb-4">
      <div>
        <slot name="breadcrumb" />
        <div name="title" class="title-client">
          Groups
        </div>
      </div>

      <base-search
        v-model="searchTerm"
        class="search-bar"
        icon-position="left"
        :value="search"
        @input="$emit('onSearch', $event)"
      />

      <base-button
        class="custombutton-clients"
        @click="$emit('createGroup')"
      >
        <base-icon
          icon="plus-original"
        />Group
      </base-button>
    </div>

    <base-list
      :loading="loading"
      :page-size="10"
      :items="items"
      :count="count"
      :mode="mode"
      :show-load-more="showLoadMore"
      attach-scroll-to-window
      :load-more-bottom-threshold="10"
      @reload="$emit('reload')"
      @pageChange="$emit('pageChange', $event)"
      @load-more="$emit('load-more')"
      @reached-bottom="$emit('load-more')"
    >
      <template slot="loading">
        <base-skeleton
          v-for="n in 4"
          :key="n"
          :opacity="0 + (1 /n)"
        >
          <div class="d-flex align-items-center">
            <div class="skeleton__circle mr-4" />
            <div
              class="skeleton__item mr-5"
              style="max-width: 150px"
            />
          </div>
        </base-skeleton>
      </template>

      <template
        v-slot:default="{item}"
      >
        <GroupCell
          :item="item"
          @click="$emit('cellClicked', item)"
          @delete="onDeleteClicked(item)"
        />
      </template>

      <template
        slot="nodata"
      >
        <client-empty-message v-if="search !== ''" />
        <template v-else>
          <empty title="No groups yet">
            <a
              href="#"
              class="link-orange font-weight-bold"
              @click.prevent="$emit('createGroup')"
            >Add a group</a> to start organizing
          </empty>
        </template>
      </template>
    </base-list>
    <base-confirm-dialog-extended
      v-if="groupToDelete"
      :title="`Are you sure you want to delete '${groupToDelete.name}'?`"
      message=""
      positive-text="Accept"
      @confirmed="onConfirmDelete"
      @cancelled="onCancelDelete"
    />
  </base-widget>
</template>

<script>

import GroupCell from './GroupsList/GroupCell';
import ClientEmptyMessage from './ClientsList/ClientEmptyMessage';
import minHeightMixin from '../mixins/minheight';

export default {
  name: 'Groups',
  components: {
    GroupCell,
    ClientEmptyMessage,
  },
  mixins: [minHeightMixin],
  props: {
    search: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'pagination',
    },
    showLoadMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupToDelete: null,
      searchTerm: '',
      searchTimer: null,
      startLoad: false,
    };
  },
  computed: {
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
    permissionViewsAllClient() {
      return this.usePermission('view_all_clients') || this.useFeature('edits_sendable_to_all_institution_clients');
    },
    defaultInitialTab() {
      if (this.permissionViewsAllClient) {
        return 2;
      }
      return 1;
    },
    tabs() {
      if (this.isAdminMode) {
        return ['Clients', 'Groups'];
      }
      if (this.permissionViewsAllClient) {
        return ['My Clients', 'All Clients', 'Groups'];
      }
      return ['My Clients', 'Groups'];
    },
  },
  watch: {
    searchTerm(newval) {
      this.cancelSearchTimer();
      if (newval.length) {
        // Cancel previous timer
        this.setSearchTimer(newval);
      } else {
        this.$emit('onSearch', '');
      }
    },
    items(newItems, oldItems) {
      if (newItems.length !== oldItems.length) {
        return this.suffleItems();
      }
      for (let i = 0; i < newItems.length; i++) {
        if (newItems[i]?.name !== oldItems[i]?.name) {
          return this.suffleItems();
        }
      }
      if (!this.startLoad) {
        this.suffleItems();
        this.startLoad = true;
      }
      return null;
    },
  },
  mounted() {
    setTimeout(this.suffleItems(), 2000);
  },
  methods: {
    setSearchTimer(term) {
      this.searchTimer = window.setTimeout(() => {
        this.$emit('onSearch', term);
      }, 500);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        window.clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },
    onDeleteClicked(item) {
      this.groupToDelete = item;
    },
    onConfirmDelete() {
      const item = this.groupToDelete;
      this.groupToDelete = null;
      this.$emit('delete', item);
    },
    onCancelDelete() {
      this.groupToDelete = null;
    },
    suffleItems() {
      const index = this.items.findIndex((x) => x.is_supergroup);
      const checkAll = this.items.find((x) => x.is_supergroup);
      if (checkAll.is_supergroup) {
        const startSuffleItems = this.items.slice(index);
        const endSuffleItems = this.items.slice(0, index);
        const result = [...startSuffleItems, ...endSuffleItems];
        this.items = result;
      }
      return this.items;
    },
  },
};
</script>
<style lang="scss" scoped>
.search-bar {
  margin-left: auto;
  min-width: 310px;

  &::v-deep input {
    // min-height: 42px;
    font-size: 0.875rem;
  }
}
.group-list {
  &__create-button {
    min-width: 95px;
    margin-left: 1rem;
  }
}
.cells_container {
  overflow-y: scroll;
  max-height: 40vh;
}
::v-deep .base-search {
    margin-right: 0;
    max-width: 320px;
    &__input {
      // font
      font-family: 'SilkaLight' !important;
      // design
      background-color: #FFF;
      border: 1px solid #C6C6C6;
      border-radius: 5px;
      font-family: $font-family-sans-serif-medium;
      max-width: 100%;
    }
  }
::v-deep .base-search__icon--left {
  margin-left: 5px;
}
.custombutton-clients{
  font-weight: 500;
  font-size: 14px;
  color: #FFF;
  display: flex;
  padding: 8.5px 10px;
  gap: 8px;
  margin-left: 16px;
  margin-right: unset;
  max-width: 130px;
  max-height: 36px;
  background: #333333;
  border-radius: 5px;
}
::v-deep .base-tabs__item{
  margin-left: 4px;
  color: #AAAAAA;
  &.active {
    color: #333333;
  }
}
::v-deep .message{
  padding: 12px !important;
}
</style>
